import { render } from "./Realtime.vue?vue&type=template&id=09cb1b31&scoped=true&ts=true"
import script from "./Realtime.vue?vue&type=script&lang=ts"
export * from "./Realtime.vue?vue&type=script&lang=ts"

import "./Realtime.vue?vue&type=style&index=0&id=09cb1b31&scoped=true&lang=less"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09cb1b31"]])

export default __exports__